import { render, staticRenderFns } from "./DialogCustom.vue?vue&type=template&id=5f23ac26&scoped=true"
import script from "./DialogCustom.vue?vue&type=script&lang=js"
export * from "./DialogCustom.vue?vue&type=script&lang=js"
import style0 from "./DialogCustom.vue?vue&type=style&index=0&id=5f23ac26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23ac26",
  null
  
)

export default component.exports